// Sentry error tracking setup
// To enable Sentry, set VITE_SENTRY_DSN in your .env file
// Get your DSN from https://sentry.io

let Sentry = null

export const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  
  if (!dsn) {
    console.log('Sentry not configured. Set VITE_SENTRY_DSN to enable error tracking.')
    return
  }

  // Dynamically import Sentry only if DSN is provided
  import('@sentry/react').then((SentryModule) => {
    Sentry = SentryModule
    
    Sentry.init({
      dsn: dsn,
      integrations: [
        new Sentry.BrowserTracing(),
        new Sentry.Replay(),
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      environment: import.meta.env.MODE || 'development',
    })
    
    console.log('Sentry initialized successfully')
  }).catch((err) => {
    console.error('Failed to initialize Sentry:', err)
  })
}

export const captureException = (error, context = {}) => {
  if (Sentry) {
    Sentry.captureException(error, { extra: context })
  } else {
    console.error('Error (Sentry not initialized):', error, context)
  }
}

export const captureMessage = (message, level = 'info') => {
  if (Sentry) {
    Sentry.captureMessage(message, level)
  } else {
    console.log(`[${level}] ${message}`)
  }
}

export const setUser = (user) => {
  if (Sentry) {
    Sentry.setUser({
      id: user.id,
      email: user.email,
      username: user.username,
    })
  }
}
